import moment from 'moment';

export const compareToStartDate =
  (entity, hasDisposablePermit) => (_rule, value, callback) => {
    const startDate =
      typeof entity.getFieldValue === 'function'
        ? entity.getFieldValue('startDate')
        : moment(entity.startDate);

    const hasValidVal = moment.isMoment(value);
    const hasValidStartDate = moment.isMoment(startDate);

    if (
      hasValidVal &&
      hasValidStartDate &&
      value.isBefore(startDate, hasDisposablePermit ? 'minute' : 'day')
    ) {
      callback('Дата и время не могут быть установлены ранее даты  начала');
    } else {
      callback();
    }
  };

export const compareToCreateDate =
  (hasDisposablePermit) => (_rule, value, callback) => {
    const hasValidVal = moment.isMoment(value);
    const dateNow = moment();

    if (
      hasValidVal &&
      value.isBefore(dateNow, hasDisposablePermit ? 'minute' : 'day')
    ) {
      callback('Дата не может быть раньше текущего времени');
    } else {
      callback();
    }
  };
